import {
  getCustomerMovementHistoryFromRemote,
  shouldReadCustomerFromRemoteOnWeb,
} from './customerRepositoryShared';
import type { CustomerMovementHistoryFilters, CustomerMovementRow } from '../domain/customerTypes';

/**
 * ADR-017 Fase 4: SQLite eliminado como path de datos operacional.
 * `db` es un stub que retorna `[]` (sin error), por lo que el path SQLite
 * siempre retornaba vacío y el fallback remoto en el catch nunca se alcanzaba.
 * Ahora usamos el camino remoto directamente cuando hay sesión/online.
 */
export const DEFAULT_MOVEMENTS_PAGE_SIZE = 20;

export const getCustomerMovementHistory = async (
  customerId: string,
  limit = DEFAULT_MOVEMENTS_PAGE_SIZE,
  offset = 0,
  filters?: CustomerMovementHistoryFilters
): Promise<CustomerMovementRow[]> => {
  if (shouldReadCustomerFromRemoteOnWeb()) {
    return getCustomerMovementHistoryFromRemote(customerId, limit, offset, filters);
  }
  return [];
};

export const getCustomerMovementHistoryForExport = async (
  customerId: string,
  filters?: CustomerMovementHistoryFilters,
  maxRows = 10_000
): Promise<CustomerMovementRow[]> => {
  if (shouldReadCustomerFromRemoteOnWeb()) {
    return getCustomerMovementHistoryFromRemote(customerId, maxRows, 0, filters);
  }
  return [];
};

export const fetchCustomerMovements = async (
  customerId: string,
  opts?: { limit?: number; offset?: number }
): Promise<CustomerMovementRow[]> => {
  const limit = opts?.limit ?? DEFAULT_MOVEMENTS_PAGE_SIZE;
  const offset = opts?.offset ?? 0;
  return getCustomerMovementHistory(customerId, limit, offset, undefined);
};
